
  var _styles = {
  "draw-module-container": {
    "display": "flex",
    "flexDirection": "column",
    "width": "9.36rem",
    "borderRadius": "0.48rem",
    "backgroundColor": "rgb(255,255,255)",
    "paddingTop": "0.32rem",
    "paddingRight": "0.32rem",
    "paddingBottom": "0.24rem",
    "paddingLeft": "0.32rem",
    "marginTop": "0.32rem",
    "marginRight": "auto",
    "marginBottom": 0,
    "marginLeft": "auto"
  },
  "draw-module-title-row": {
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "space-between",
    "alignItems": "center",
    "marginBottom": "0.26667rem"
  },
  "draw-module-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.4rem"
  },
  "draw-module-rule": {
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.32rem"
  },
  "draw-module-bottom-row": {
    "display": "flex",
    "flexDirection": "row",
    "alignItems": "center"
  },
  "draw-module-rewards-row": {
    "display": "flex",
    "flexDirection": "row",
    "flex": 1,
    "gridGap": "0.16rem",
    "gap": "0.16rem"
  },
  "draw-module-reward-card": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "flex-start",
    "justifyContent": "center",
    "backgroundColor": "rgb(255,249,224)",
    "borderRadius": "0.21333rem",
    "paddingTop": "0.16rem",
    "paddingRight": "0.18667rem",
    "paddingBottom": "0.16rem",
    "paddingLeft": "0.18667rem",
    "minWidth": "1.86667rem",
    "flex": 1
  },
  "draw-module-reward-tag": {
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "marginBottom": "0.05333rem"
  },
  "draw-module-reward-amount": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.48rem",
    "lineHeight": "0.64rem"
  },
  "draw-module-reward-desc": {
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "marginTop": "0.05333rem"
  },
  "draw-module-btn-area": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "marginLeft": "0.4rem",
    "flexShrink": 0
  },
  "draw-module-btn-wrapper": {
    "width": "2.05333rem",
    "height": "0.8rem",
    "borderRadius": "0.4rem",
    "overflow": "hidden"
  },
  "draw-module-btn": {
    "width": "2.05333rem",
    "height": "0.8rem",
    "borderRadius": "0.48rem",
    "display": "flex",
    "flexDirection": "row",
    "justifyContent": "center",
    "alignItems": "center"
  },
  "draw-module-btn--disabled": {
    "opacity": 0.5
  },
  "draw-module-btn-text": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.32rem"
  },
  "draw-module-btn-text--disabled": {
    "opacity": 0.5
  },
  "draw-module-chance": {
    "color": "rgb(136,136,136)",
    "fontFamily": "PingFang SC",
    "fontWeight": "400",
    "fontSize": "0.26667rem",
    "lineHeight": "0.37333rem",
    "marginTop": "0.10667rem",
    "textAlign": "center"
  },
  "draw-prize-modal-content-wrap": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center"
  },
  "draw-prize-modal-content": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "width": "100%",
    "height": "100%",
    "position": "relative",
    "marginLeft": "0.4rem"
  },
  "draw-prize-modal-header": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%",
    "marginBottom": "0.42667rem"
  },
  "draw-prize-modal-title": {
    "color": "rgb(64,21,2)",
    "fontFamily": "PingFang SC",
    "fontWeight": "500",
    "fontSize": "0.42667rem",
    "lineHeight": "0.56rem",
    "marginTop": "0.72rem"
  },
  "draw-prize-modal-card": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center",
    "justifyContent": "center",
    "width": "100%",
    "height": "2.88rem"
  },
  "draw-prize-modal-content-text": {
    "color": "rgb(64,21,2)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.53333rem",
    "lineHeight": "0.74667rem"
  },
  "draw-prize-modal-tip": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.32rem",
    "lineHeight": "0.42667rem",
    "marginTop": "0.21333rem"
  },
  "draw-prize-modal-close-btn": {
    "borderRadius": 0
  },
  "draw-no-prize-modal-content-wrap": {
    "display": "flex",
    "flexDirection": "column",
    "alignItems": "center"
  },
  "draw-no-prize-modal-close-btn": {
    "borderRadius": 0
  },
  "draw-no-prize-modal-title": {
    "color": "rgb(17,17,17)",
    "fontFamily": "PingFang SC",
    "fontWeight": "600",
    "fontSize": "0.90667rem",
    "marginTop": "1.01333rem"
  },
  "draw-no-prize-modal-content": {
    "fontWeight": "400",
    "color": "rgb(85,85,85)",
    "fontFamily": "PingFang SC",
    "fontSize": "0.37333rem",
    "marginTop": "0.14667rem"
  },
  "draw-prize": {
    "color": "rgb(17,17,17)"
  }
};



  module.exports = _styles;
  